module.exports = __webpack_public_path__ + "img/xqimg7.df949497.png";